import React from 'react';
import { Box } from '@mui/material';

import Question from '../question';
import Markdown from '../markdown';

const Section = (props) => {
    const { section, appInstId } = props;

    return (
        <Box>
            <Box
                sx={{
                    margin: '2rem',
                }}
            >
                <Markdown>{section.headerMarkdown['en-US']}</Markdown>
            </Box>

            <Box
                sx={{
                    paddingLeft: '1rem',
                }}
            >
                {section?.questions?.map((question, i) => (
                    <Question
                        question={question}
                        appInstId={appInstId}
                        key={`question-${i}`}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default Section;
